module.exports = __webpack_public_path__ + "img/img5.af7d758e.svg";